import { Flex, HStack, StackProps, Text } from "@chakra-ui/react";
import { ChatInterface } from "../../constants/Chat";
import { useGetUserLoginStore } from "../../store/useGetUserLoginStore";
import { formatTime } from "../../utils/helperFunction";
import { ProductChat } from "../dashboard_buyer_page/ProductChat";

interface Props extends StackProps {
  data: ChatInterface;
}

export const ChatBox = ({ data, ...rest }: Props) => {
  const { currentActiveUser } = useGetUserLoginStore();

  const ProductChatComponent = () => {
    if ("product" in data) {
      return (
        <ProductChat
          data={data.product}
          w={"fit-content"}
          alignSelf={
            data.sender_user_type === currentActiveUser?.role ? "end" : "start"
          }
          mt={4}
          mr={data.sender_user_type === currentActiveUser?.role ? 4 : undefined}
          ml={data.sender_user_type === currentActiveUser?.role ? undefined : 4}
          mb={-2}
        />
      );
    }
  };

  return (
    <>
      <ProductChatComponent />

      <HStack
        py={1}
        px={4}
        flexDirection={
          data.sender_user_type === currentActiveUser?.role
            ? "row-reverse"
            : undefined
        }
        {...rest}
      >
        <Flex
          w={"fit-content"}
          p={2}
          borderTopLeftRadius={"xl"}
          borderTopRightRadius={"xl"}
          borderBottomRightRadius={
            data.sender_user_type === currentActiveUser?.role ? undefined : "xl"
          }
          borderBottomLeftRadius={
            data.sender_user_type === currentActiveUser?.role ? "xl" : undefined
          }
          bg={
            data.sender_user_type === currentActiveUser?.role
              ? "blue.100"
              : "white"
          }
          flexDirection={"row"}
          gap={1}
        >
          <Text
            textStyle={"b-reg"}
            color={"black"}
            maxWidth={{ base: "25ch", md: "40ch", lg: "60ch" }}
            fontSize={15}
          >
            {data.message}
          </Text>

          <Text
            pt={1}
            pl={1}
            fontSize="2xs"
            variant={"secondary"}
            alignSelf={"flex-end"}
            color={"black"}
          >
            {formatTime(data.timestamp.toString())}
          </Text>
        </Flex>
      </HStack>
    </>
  );
};
